import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  /** Page palette: bright "court" look or the dark "midnight" arena look. */
  theme?: 'court' | 'midnight';
}
const THEME_COLORS = {
  court: '#f3f6fb',
  midnight: '#050c1c'
};
export function App({
  theme = 'court'
}: AppProps) {
  useMetaPixel();
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'midnight') root.dataset.theme = 'midnight';else delete root.dataset.theme;
    document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', THEME_COLORS[theme]);
  }, [theme]);
  return <div className="w-full bg-ink font-sans text-fg" data-id="element-0" data-mp="5ygolyg4xb6">
      <Hero data-id="element-1" data-mp="5gg5d4r3wxg" />
      <main data-id="element-2" data-mp="82lr78302d1">
        <TestimonialsSection data-id="element-3" data-mp="7st1bvnjh3n" />
        <ProblemSection data-id="element-4" data-mp="2zlld2w2kqak3" />
        <VolumesSection data-id="element-5" data-mp="2zmeo498kfm81" />
        <BonusesSection data-id="element-6" data-mp="2zn6actg9w7ln" />
        <OfferSection data-id="element-7" data-mp="33morde4z3yj7" />
        <GuaranteeSection data-id="element-8" data-mp="33lwywc6oagx5" />
        <FaqSection data-id="element-9" data-mp="33n6yx6x35z6f" />
        <FinalCtaSection data-id="element-10" data-mp="33orjc3pos1qk" />
      </main>
      <Footer data-id="element-11" data-mp="38l8gtoirzsgb" />
      <StickyCta data-id="element-12" data-mp="38kqc03i1s5ws" />
    </div>;
}